module.exports = __webpack_public_path__ + "static/img/1.d05e8d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/1.png
// module id = c3WK
// module chunks = 0